<template>
    <div class="wrapper">
        <div class="info">
            <span class="label">
                <!-- 姓名 -->
                {{$t('name')}}：</span>
            <div class="r">
                <el-input type="text" class="input" v-model="form.name"></el-input>
            </div>
        </div>
        <div class="info">
            <span class="label">{{$t('AlipayAccount')}}</span>
            <div class="r">
                <el-input type="text" class="input" v-model="form.account_number"></el-input>
            </div>
        </div>
        <div class="info">
            <!-- 验证码 -->
            <span class="label">{{$t('verificationCode')}} ：</span>
            <div class="r">
                <el-input type="text" class="input" v-model="form.verify_sms"></el-input>
            </div>
            <div>
                <div class="code-btn" @click="sendCode" v-show="verification">{{sendText}}</div>
                <div class="code-btn not" v-show="!verification">{{$t('toSend')}}({{timer}})</div>
            </div>
        </div>

        <!-- <div class="info">
            <span class="label">是否默认</span>
            <div class="r">
                <el-radio v-model="form.is_default" :label="1">是</el-radio>
                <el-radio v-model="form.is_default" :label="2">否</el-radio>

            </div>
        </div> -->

        <div class="save" @click="saveInfo">{{$t('save')}}</div>


        <el-table
        v-if="tableList.length > 0"
        :data="tableList"
        style="width: 100%; margin-top: 20px">
            <el-table-column
                prop="account_number"
                :label="$t('account')"
                width="180">
            </el-table-column>
            <el-table-column
                prop="name"
                :label="$t('name')"
                width="180">
            </el-table-column>
            <el-table-column
                prop="ctime"
                :label="$t('addTime')">
            </el-table-column>

            <!-- <el-table-column
                label="操作"
                width="100">
                <template slot-scope="scope">
                    <el-button @click="handleClick(scope.row)" type="text" size="small">删除</el-button>
                </template>
            </el-table-column> -->
        </el-table>

    </div>
</template>

<script>
export default {
    data() {
        return {
            form: {
                name: '',
                account_number: "",
                verify_sms: "",
                is_default: 2
            },
            verification: true,
            sendText: this.$t('getVerificationCode'),
            timer: 60,
            auth_timer: "",
            tableList: []
        }
    },
    created(){
        this.getalipaylist()
    },
    methods: {
        // 删除
        handleClick() {
            const _this = this
            this.$confirm( _this.$t('tipsType.remove'), _this.$t('tips'), {
                confirmButtonText: _this.$t('confirm'), // '确定',
                cancelButtonText: _this.$t('cancel'), //'取消',
                type: 'warning'
                }).then(() => {
                    this.$message({
                        type: 'success',
                        message: _this.$t('successfullyDelete')// '删除成功!'
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message:_this.$t('cancel') // '已取消删除'
                    });          
                });

        },
        // 支付宝账号列表
        getalipaylist() {
            this.$api.getalipaylist().then(res =>{
                if(res.status) {
                    this.tableList = res.data
                }
            })
        },
        // 发送验证码
        sendCode() {
            let mobile = JSON.parse(localStorage.getItem('userInfo')).mobile
            
            if(mobile) {
                this.$api.sms({ mobile, code: "veri" }).then(res => {
                    if (res.status) {
                        this.verification = false;
                        this.countDown(); // 执行验证码计时
                    }
                });
            } else {
                this.$message({
                    message: "error",
                    type: "warning"
                })
            }
            
        },
        // 保存信息
        saveInfo() {
            this.$api.addalipay(this.form).then(res => {
                if(res.status) {
                    this.$message({
                        message: res.msg,
                        type: "success"
                    })
                } else {
                    this.$message({
                        message: res.msg,
                        type: "warning"
                    })
                }
            })
        },
        countDown() {
            let auth_timer = setInterval(() => {
                // 定时器设置每秒递减
                this.timer--; // 递减时间
                if (this.timer <= 0) {
                this.verification = true; // 60s时间结束还原v-show状态并清除定时器
                this.timer = 60;
                clearInterval(auth_timer);
                this.sendText = this.$t('toSend');
                }
            }, 1000);
        }
    }
}
</script>

<style lang="scss" scoped>
@import "~@/assets/css/variable.scss";
.code-btn {
    cursor: pointer;
    margin-left: 20px;
}
.input {
  width: 200px;
}
.wrapper {
  .save {
    width: 120px;
    height: 30px;
    text-align: center;
    line-height: 30px;
    background: $theme-color;
    color: #fff;
    margin-left: 110px;
    margin-top: 30px;
    cursor: pointer;
  }
  .info {
    display: flex;
    align-items: center;
    margin-bottom: 30px;
    &.head {
      align-items: flex-start;
      .label {
        padding-top: 10px;
      }
    }
    .label {
      display: inline-block;
      width: 90px;
      margin-right: 20px;
    }
    .r {
      .user-head {
        width: 80px;
        height: 80px;
        border-radius: 50%;
        position: relative;
        &:hover {
          .change {
            display: block;
          }
        }
        .input-file {
          position: absolute;
          width: 100%;
          height: 100%;
          top: 0;
          left: 0;
          opacity: 0;
          cursor: pointer;
          z-index: 99;
        }
        .change {
          display: none;
          position: absolute;
          top: 50%;
          left: 50%;
          width: 70px;
          height: 18px;
          margin-left: -35px;
          line-height: 18px;
          text-align: center;
          margin-top: -8px;
          background: #757575;
          color: #fff;
          cursor: pointer;
        }
        img {
          display: block;
          width: 100%;
          height: 100%;
          border-radius: 50%;
        }
      }
      .info-input {
        width: 160px;
        height: 24px;
        line-height: 24px;
        border: 1px solid $border;
        padding-left: 12px;
      }
    }
  }
}

</style>